import React from 'react'
import { Tooltip, IconButton, Stack } from '@mui/material'
import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';

function CashjobRowDelete({rows, setRows, rowId, hoveredRow, handleDelete}) {


    // Function to delete a row by ID
    const deleteRow = (sl) => {
            const id = rows.find(item=> item.id===sl).labourId
            if(id){
                handleDelete(id)
            }          
            const updatedRows = rows.filter((row) => row.id !== sl);
        
            // After filtering, reassign consecutive IDs to the rows
            const updatedRowsWithConsecutiveIDs = updatedRows.map((row, index) => ({
              ...row,
              id: index + 1,
            }));
        
            setRows(updatedRowsWithConsecutiveIDs);
        //   else {
        //     // If there's only one row left, reset its ID to 1
        //     setRows([{ id: 1, name: '' }]);
        //   }
    };

    return (
        <Stack direction='row' spacing={1}>
            {rowId === hoveredRow &&
             <Tooltip title="Remove">
             <IconButton size='small' onClick={() => { deleteRow(rowId) }} >
             <RemoveCircleOutlinedIcon />
             </IconButton>
         </Tooltip>
            }
           
        </Stack>
    )
}

export default CashjobRowDelete